<script>
    import page from 'page';
    import Icon from '../components/Icon.svelte';
    import { IDLE, INCALL, OUTCALL, OUTGOING } from 'common/callState';
    import { formatDuration } from 'services/utils';
    import { createEventDispatcher, onMount } from 'svelte';
    import { tweened } from 'svelte/motion';
    import ButtonBase from '../common/ButtonBase.svelte';
    import Modal from 'screens/Modal.svelte';
    import TakeNote from 'screens/TakeNote.svelte';
    import { getContactName } from 'common/utils.js';
    import { fetchTeamMembers } from '../domain/session/receivers.actions';
    import userStore from 'store/user';
    let microphone = false;
    let pause = false;

    export let session = {};
    export let state;
    export let peer;
    export let setNotes;
    export let setCallActive;
    export let setTakeNote;
    export let take_note;

    const dispatch = createEventDispatcher();

    let duration = tweened(0);
    let direction = session && session.direction == 'incoming' ? 'Incoming Call' : 'Outgoing Call';
    let exceededNotification = ''
    let team_members = []
    let transferCallFreeInput = ''
    let showTransferCallList = false
    let stopTimer;

    $: {
        if (state === INCALL || state === OUTCALL) {
            duration.set(0);
            const interval = setInterval(() => {
                duration.update((n) => { 
                    const r = n + 1
                    session.duration = r
                    // checkForTermination(r)
                    return r;
                });
            }, 1000);
            stopTimer = () => clearInterval(interval);
        }
    }

    $: {
        if (state === IDLE && stopTimer) {
            stopTimer();
        }
    }

    let notes = '';

    const checkForTermination = (duration) => {
        
        const activeNumber = localStorage.getItem("active_number")
        if ( !activeNumber ) {
            return;
        }

        const number = JSON.parse(activeNumber)

        const { max_call_duration_limit = 0, min_call_duration_limit = 0 } = number;

        if (!max_call_duration_limit && !min_call_duration_limit) {
            return;
        }
        
        if (!!max_call_duration_limit && duration >= max_call_duration_limit) {
            hangup()
        }

        if (!!min_call_duration_limit && duration >= min_call_duration_limit) {
            const limit = !!max_call_duration_limit ? ` This call will terminate in ${max_call_duration_limit - duration} sec`: ''
            exceededNotification = 'call limit exceeded.' + limit; // sends a warning
        }
    };

    const toggleMute = () => {
        microphone = !microphone;

        if (microphone) {
            dispatch('unMute');
        } else {
            dispatch('mute');
        }
    };

    let peer_name = getContactName(peer);

    const toggleHold = () => {
        pause = !pause;

        if (pause) {
            dispatch('hold');
        } else {
            dispatch('unHold');
        }
    };

    const toggleTransfer = () => {
        showTransferCallList = !showTransferCallList
    }

    const transfer = () => {
        toggleTransfer();
        dispatch('transfer', { number: transferCallFreeInput });
    };

    const initCallTransfer = member => {
        transferCallFreeInput = member.line.username; 
        transfer()
    }

    const hangup = (from) => {
        if (state !== IDLE) {
            dispatch('hangup');
        }

        if (state === IDLE || state == OUTGOING || notes.length === 0) {
            session.state = IDLE
            setCallActive(false);
        }
    };

    const saveNote = () => {
        setNotes(notes);
        setTakeNote(false);

        if (state === IDLE) {
            setCallActive(false);
        }
    };

    onMount(async () => {
        let business_number_id = null;

        userStore.subscribe((value) => {
            business_number_id = value.mobileID;
        })

        try {
            team_members = await fetchTeamMembers(business_number_id)
        } catch (e) {
            // console.log("ERR_OCCURED:", e.toString())
        }
    });

</script>

<div id="active-call" class="row content">
    <section class="display-flex ">
        <Modal open={take_note} close_on_escape={true} close_on_background_click={true}>
            <TakeNote
                bind:notes
                on:savenote={saveNote}
                on:hangup={() => {
                    hangup('notes');
                    setTakeNote(false);
                }}
                on:mute={toggleMute}
                {state}
                {peer}
                {duration}
                {peer_name}
            />
        </Modal>
        <div class="call-time">{formatDuration($duration)}</div>
        <div class="call-info">
            {direction}: <span class="caller-name">{peer_name}</span>
        </div>
        <div class="call-info" style="color: red;">
            {exceededNotification}
        </div>
        <div class="caller-avatar active-call-avatar">
            <Icon icon="caller-avatar" size="10" />
        </div>
        <div class="call-actions">
            <div />
            <ButtonBase
                disabled={state !== INCALL && state !== OUTCALL}
                on:click={() => setTakeNote(true)}
                style="width: 100%;"
            >
                <div class="icon-bg">
                    <Icon icon="add-note" />
                </div>
            </ButtonBase>
            <ButtonBase
                disabled={state !== INCALL && state !== OUTCALL}
                on:click={toggleMute}
                style="width: 100%;"
            >
                <div class="icon-bg">
                    <Icon icon={microphone ? 'microphone' : 'microphone-mute'} color={!microphone ? '#EF3333' : '#474B50'} />
                </div>
            </ButtonBase>
            <ButtonBase
                disabled={state !== INCALL && state !== OUTCALL}
                on:click={toggleHold}
                style="width: 100%;"
            >
                <div class="icon-bg">
                    <Icon icon="pause" size="24" color={pause ? '#EF3333' : '#474B50'} />
                </div>
            </ButtonBase>
            <ButtonBase
                on:click={toggleTransfer}
            >
                <div class="icon-bg">
                    <Icon icon="add-to-call" size="24" color={showTransferCallList ? '#EF3333': '#474B50'} />
                </div>
            </ButtonBase>
        </div>
        <button class="button danger" on:click={() => hangup('call')}>End Call</button>

        <hr/>
        {#if session.transferStatus}
            <div
                class="alert alert-borderless shadow alert-primary mb-2"
                role="alert"
            >
                <small>{ session.transferStatus }</small>
            </div>
        {/if}
        {#if showTransferCallList}
            <strong class="transfer-call-header">Transfer call to team member</strong>
            <div class="app-search d-md-block" >
                <div class="dialer">
                    <input
                        type="text"
                        class="dail-number"
                        placeholder="Enter phone number"
                        bind:value={transferCallFreeInput}
                        id="transfer-phone-input"
                        style="border-radius: 3px 0 0 3px"
                        disabled={session.isTransfer}
                    />

                    <ButtonBase
                        on:click={transfer}
                        disabled={session.isTransfer}
                    >
                        <div
                            type="submit"
                            class="dialer-icon"
                        >
                            <Icon icon="dialer" color="#30A059" />
                        </div>
                    </ButtonBase>
                </div>
            </div>
            <div class="transfer-call-list">
                <!-- Primary Alert -->
                {#if !team_members.length}
                    <div>
                        <small>No team member registered. You can manually add new call owner above.</small>
                    </div>
                {:else}
                    <br>
                    <small>or select team member</small>
                    <hr>
                    <ul class="list-group">
                        {#each team_members.filter( member => (member.receiver_name.toUpperCase().indexOf(transferCallFreeInput.toUpperCase()) > -1 || member.line.username.toUpperCase().indexOf(transferCallFreeInput.toUpperCase()) > -1) ) as member (member)}
                            <li class="list-group-item">
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <img src="@/assets/images/anonymous.png" alt="" class="avatar-xs rounded-circle" />
                                    </div>
                                    <div class="flex-grow-1 ms-2" style="text-align: left">
                                        { member.receiver_name }
                                    </div>
                                    <div>
                                        <button
                                            disabled={session.isTransfer}
                                            type="button"
                                            class="transfer-call-btn"
                                            on:click={initCallTransfer(member)}
                                        >
                                            Transfer
                                        </button>
                                    </div>
                                </div>
                            </li>
                        {/each}
                    </ul>
                {/if}
            </div>
        {/if}
    </section>
</div>

<style lang="scss">
    #active-call {
        section {
            margin: 2.5rem;
            .transfer-call-header {
                margin: 5px 0px;
                text-align: center;
                font-size: 10px;
            }
            .button {
                width: 100%;
                background-color: #ef3333;
            }
            .call-time {
                font-family: 'Urbanist';
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 140%;
                text-align: center;
                color: #474b50;
                margin-bottom: 20px;
            }
            .call-info {
                font-family: 'Urbanist';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 140%;
                color: #474b50;
            }
            .active-call-avatar {
                width: 30px;
                height: 30px;
                margin-top: 24px;
                margin-bottom: 20px;
                background: #673ab3;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .icon-bg {
                width: 52px;
                height: 52px;
                background: #f5f5f5;
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .call-actions {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 0.5rem;
                margin-bottom: 44px;
            }
            .list-group {
                list-style: none;
                margin: 0px;
                padding: 0px;
                overflow-y: scroll;
                height: 3rem;
            }

            .list-group-item div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 2px;
                font-size: 10px;
            }

            .transfer-call-btn {
                border: none;
                color: white;
                background: #ffc211;
                border-radius: 4px;
                margin-left: 10px;
            }
            .dialer {
                display: grid;
                grid-template-columns: 1fr 48px;
                gap: 12px;
                width: 100%;
                input {
                    padding: 0px 16px;
                    width: 100%;
                    color: #000000;
                }
            }
            .dialer-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                background: #dff9e8;
                border-radius: 4px;
            } 
        }
    }
</style>
<!-- -->